// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3qWBY","bigColWidth":"Table_bigColWidth__ti8bl","biggerColWidth":"Table_biggerColWidth__20S3v","row":"Table_row__1OPvw","col":"Table_col__3wSf0"};